export enum TransportType {
  PUBLIC_USE_TRUCK = 1, // Φορτηγό Δημόσιας Χρήσης
  PRIVATE_USE_TRUCK = 2, // Φορτηγό Ιδιωτικής Χρήσης
  SHIP = 3, // Πλοίο
  TRAIN = 4, // Τρένο
  AIRPLANE = 5, // Αεροπλάνο
  OTHER = 6, // Λοιπά Μεταφορικά Μέσα (π.χ Δίκυκλα, ..)
  NONE = 7, // Άνευ
}

export enum DELIVERY_NOTE_STATUS_CODE {
  REGISTERED = 'REGISTERED', // Το ΔΑ έχει εκδοθεί επιτυχώς.
  IN_TRANSIT = 'IN_TRANSIT', // Η διακίνηση έχει ξεκινήσει.
  DELIVERED_BY_CARRIER = 'DELIVERED_BY_CARRIER', // Ο μεταφορέας δήλωσε παράδοση (αναμονή επιβεβαίωσης από λήπτη B2B).
  COMPLETED = 'COMPLETED', // Η διακίνηση ολοκληρώθηκε με επιτυχία.
  REJECTED = 'REJECTED', // Ο λήπτης απέρριψε την παραλαβή.
  CANCELLED = 'CANCELLED', // Ο εκδότης ακύρωσε το ΔΑ πριν την έναρξη της διακίνησης.
  FAILED_DELIVERY = 'FAILED_DELIVERY', // Ο μεταφορέας δήλωσε αποτυχία παράδοσης.
  IN_TRANSIT_RETURN = 'IN_TRANSIT_RETURN', // Ο μεταφορέας επιστρέφει με εμπόρευμα.
}

/**
 * Used in gsis doc response `AadeBookInvoiceType`
 */
export enum DeliveryNoteLifecycleCode {
  REGISTERED = 1, // Το ΔΑ έχει εκδοθεί επιτυχώς.
  CANCELLED = 2, // Ο εκδότης ακύρωσε το ΔΑ πριν την έναρξη της διακίνησης.
  IN_TRANSIT = 3, // Η διακίνηση έχει ξεκινήσει.
  REJECTED = 4, // Ο λήπτης απέρριψε την παραλαβή.
  DELIVERED_BY_CARRIER = 5, // Ο μεταφορέας δήλωσε παράδοση (αναμονή επιβεβαίωσης από λήπτη B2B).
  FAILED_DELIVERY = 7, // Ο μεταφορέας δήλωσε αποτυχία παράδοσης.
  COMPLETED = 8, // Η διακίνηση ολοκληρώθηκε με επιτυχία.
  IN_TRANSIT_RETURN = 9, // Ο μεταφορέας επιστρέφει με εμπόρευμα.
}

export enum PackagingType {
  PALLET = 1, // Παλέτα
  BOX = 2, // Κούτα
  CRATE = 3, // Κιβώτιο
  BARREL = 4, // Βαρέλι
  SACK = 5, // Σάκος
  OTHER = 6, // Λοιπά
}

interface LocationType {
  longitude: number;
  latitude: number;
}

export interface TransportDetailType {
  vehicleNumber: string; // [REQUIRED] Αριθμός Μεταφορικού Μέσου Μέγιστο επιτρεπτό μήκος 50
  transportType: TransportType; // Είδος Μεταφορικού Μέσου
  timeStamp?: string;
  carrierVatNumber: string;
  pNumber?: string; // Αριθμός κυκλοφορίας "Ρ" (αριθμός κυκλοφορίας του επικαθήμενου/ρυμουλκούμενου οχήματος)
  location?: LocationType;
}

export interface DeliveryNoteStatus {
  invoiceMark: string; // Documentation is using `mark` field
  status: DELIVERY_NOTE_STATUS_CODE; // Κωδικός Αποτελέσματος
  dispatchTimestamp: string; // Ημερομηνία και Ώρα Εκκίνησης/Μεταφόρτωσης Διακίνησης - Datetime ISO string
  lifecycleHistory?: DeliveryEventType | DeliveryEventType[]; // Returned after 1st action `RegisterTransfer` is submitted
}

export interface DeliveryEventType {
  eventType: 'RegisterTransfer' | 'ConfirmOutcome' | 'Rejection' | 'ConfirmReturn' | 'RegisterTransferReturn'; // Ο τύπος του γεγονότος
  eventTimestamp: string; // Datetime ISO string
  actorVat: string;
  mark?: string;
  transportDetails?: TransportDetailType;
  outcomeDetails?: OutcomeDetailsType;
  rejectionDetails?: RejectionDetailsType;
}

export enum CONFIRM_DELIVERY_OUTCOME {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL',
  NONE = 'NONE',
}

interface OutcomeDetailsType {
  outcome: CONFIRM_DELIVERY_OUTCOME;
  deliveredWithoutRecipient?: boolean;
  deliveredPackaging?: PackagingDetailType[];
}

interface RejectionDetailsType {
  reason?: string;
}

export interface PackagingDetailType {
  packagingType: PackagingType;
  quantity: number; // Decimal like 10.24
  /**
   * Required when PackagingType.OTHER
   */
  otherPackagingTypeTitle?: string; // Τίτλος για Λοιπά Είδη Συσκευασίας
}
